import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subscription, timer } from 'rxjs';
import { switchMap, startWith } from 'rxjs/operators';
import { UserService } from './user.services';

@Injectable({
  providedIn: 'root'
})
export class SessionTimeoutService {
  private timeoutMinutes = 5;
  private timeoutMs = this.timeoutMinutes * 60 * 1000;
  private timeoutSubscription?: Subscription;

  constructor(private userService: UserService, private ngZone: NgZone) { }

  startMonitoring() {
    // Only start if user is logged in
    if (!this.userService.isLoggedIn()) {
      this.stopMonitoring();
      return;
    }

    // Prevent multiple subscriptions
    if (this.timeoutSubscription) {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'click'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'scroll'),
        fromEvent(document, 'touchstart')
      );

      this.timeoutSubscription = activityEvents$
        .pipe(
          startWith(null), // Start the timer immediately
          switchMap(() => timer(this.timeoutMs))
        )
        .subscribe(() => {
          this.ngZone.run(() => {
            if (this.userService.isLoggedIn()) {
              this.userService.logout();
            }
          });
        });
    });
  }

  stopMonitoring() {
    if (this.timeoutSubscription) {
      this.timeoutSubscription.unsubscribe();
      this.timeoutSubscription = undefined;
    }
  }
}
